import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mixin } from '@/store/mixin';
import LangSelect from "../common/LangSelect.vue";
import Screenfull from "../common/Screenfull";
// import TagsView from "../common/TagsView"
// import Sticky from "../common/Sticky"
import ThemePicker from "../common/ThemePicker";
// import SizeSelect from '../common/SizeSelect'
// import MainFooter from "../common/footer"
import messageInfo from "../common/messageInfo";
import verticalMenuItem from "../common/vertical-menu-item.vue";
import VueQr from 'vue-qr';
import { mapGetters, mapMutations } from 'vuex';
import cn from "../../i18n/langs/cn";
import en from "../../i18n/langs/en";
import activeMenu from '@/activeMenu';
// 加载配置在router.js 菜单关系
import { activeMenus } from '@/router/index.js';
import chatDialog from "./components/chatDialog.vue";
export default {
  data: function data() {
    return {
      detail: '',
      inAuditDialog: false,
      auditId: '',
      showBadge: true,
      apkQrcodeImg: '',
      // 二维码
      stickyTop: 20,
      box: null,
      activeName: 'messageList',
      active: false,
      headImg: "",
      nameSlot: "2222",
      tips: "android",
      logo: require("../../../public/static/img/\u4E2D\u56FD\u7535\u5EFA-N.png"),
      logoMini: require("../../../public/static/img/powerchina-mini.png"),
      logoMiniWomen: require("../../assets/img/women.jpg"),
      logoMiniMan: require("../../assets/img/man.jpg"),
      city: require("../../assets/img/city.png"),
      sex: 2,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,
      isToolbarVisible: false,
      toolbarVisibility: 'hidden',
      // 控制工具栏的显示与隐藏
      // isShowSearch: false,
      value: null,
      collapse: true,
      androidApkUrl: "",
      arr: [{
        title: "个人资料",
        router: "/main/personalCenter",
        icon: "person_outline"
      }, {
        title: "账号安全",
        router: "/main/personalSafe",
        icon: "security"
      }, {
        title: "切换部门",
        router: "/changeDept",
        icon: "swap_horiz"
      }, {
        title: "安全退出",
        router: "/",
        icon: "exit_to_app"
      }],
      ops: {
        vuescroll: {
          mode: 'slide',
          snapping: {
            enable: true,
            width: 100,
            height: 100
          }
        }
      },
      showTodoFlag: false,
      showMessageFlag: false,
      headPopover: false,
      deptId: [],
      defaultProps: {
        label: 'deptName',
        children: 'children'
      },
      getMessageInfo: [],
      queryDept: [],
      filterText: "",
      isShowDept: false,
      changeDeptDialog: false,
      userDept: "",
      pUser: null,
      isShowTop: false,
      dialogV2: false,
      dialogV3: false,
      pwdUpdateAt: ''
    };
  },
  mixins: [mixin],
  created: function created() {
    var _this = this;
    if (this.$route.name && (this.$route.name == 'dataScreening' || this.$route.name == 'international/dataScreening')) {
      this.confirmChoose(false);
    } else {
      this.confirmChoose(true);
    }
    this.roles = JSON.parse(sessionStorage.getItem('roles'));
    var user = JSON.parse(localStorage.getItem('token'));
    this.pData = JSON.parse(sessionStorage.getItem('data'));
    this.pUser = user;
    this.resetDeptFilter();
    this.getDepts();
    this.getDeptsV2();
    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("procureIsLogin", _this.$store.getters.getIsLogin);
    });
    // this.$store.watch(
    //       (state) => state.collapse,
    //       (newValue) => {
    //         console.log('全局变量的值发生了变化：', newValue);
    //       }
    //     );
  },
  components: {
    // MainFooter,
    LangSelect: LangSelect,
    messageInfo: messageInfo,
    verticalMenuItem: verticalMenuItem,
    VueQr: VueQr,
    Screenfull: Screenfull,
    ThemePicker: ThemePicker,
    chatDialog: chatDialog
    // SizeSelect
    // TagsView,
    // Sticky,
  },
  props: {
    source: String
  },
  computed: _objectSpread({
    defaultTheme: function defaultTheme() {
      return this.$store.state.settings.theme;
    },
    activeIndex: function activeIndex() {
      return activeMenu[this.$route.path] ? activeMenu[this.$route.path] : activeMenus[this.$route.path] ? activeMenus[this.$route.path] : this.$route.path;
    }
  }, mapGetters([
  // 'getMessageInfo',
  'getTodoList', 'getMessageListCount', 'getTodoListCount', "getAllCount"]), {
    getUserDepts: function getUserDepts() {
      var data = JSON.parse(sessionStorage.getItem('data'));
      if (data) {
        data.userUnits.depts.forEach(function (item) {
          if (item.branchUnitName && item.projectUnitName) {
            item['deptAllName'] = item.projectUnitName + item.deptName;
          } else if (item.branchUnitName) {
            item['deptAllName'] = item.branchUnitName + item.deptName;
          } else {
            item['deptAllName'] = item.deptName == '七局' ? '七局' : "七局" + item.deptName;
          }
        });
        return data.userUnits.depts;
      } else {
        return {};
      }
    }
  }),
  watch: {},
  activated: function activated() {
    console.log('this.$route.name', this.$route.name);
    if (this.$route.name && (this.$route.name == 'dataScreening' || this.$route.name == 'specialEquipmentManage' || this.$route.name == 'international/dataScreening')) {}
  },
  methods: _objectSpread({
    audit: function audit(pid) {
      var _this2 = this;
      this.$get('/proxy-vehicle/vehicle/study/question-daily/' + pid).then(function (res) {
        _this2.detail = res.obj;
        if (_this2.detail) {
          _this2.inAuditDialog = true;
        }
      });
    },
    auditSubmit: function auditSubmit() {
      var _this3 = this;
      this.inAuditDialog = false;
      this.$post('/study/question-daily', {
        userId: this.pData.userId,
        id: this.auditId
      }).then(function (res) {
        _this3.getUnreadMsgCnt(); //刷新
      });
    },
    closeDialog: function closeDialog() {
      this.dialogV2 = false;
      this.dialogV3 = false;
      this.$router.push({
        path: "/main/personalSafe"
      });
    },
    startInterval: function startInterval() {
      var _this4 = this;
      this.timer = setInterval(function () {
        _this4.getUnreadMsgCnt();
      }, 60000);
    }
  }, mapMutations({
    setUnits: 'setUnits',
    setSeflUnits: 'setSeflUnits'
  }), {
    getNewClass: function getNewClass() {
      if (this.$route.name && (this.$route.name == 'dataScreening' || this.$route.name == 'specialEquipmentManage' || this.$route.name == 'international/dataScreening')) {
        return this.collapse ? 'pl-0 left-10 p-0' : 'pl-260';
      } else {
        return this.collapse ? 'pl-0 left-10 p-0 pl-64' : 'pl-260';
      }
    },
    getApkQrcodeImg: function getApkQrcodeImg(apkType) {
      this.apkQrcodeImg = this.$config.baseURL + "version/latest/qrcode-img/" + apkType + "?t=" + new Date();
    },
    scroll: function scroll(_ref) {
      var scrollTop = _ref.scrollTop,
        isFixed = _ref.isFixed;
      this.stickyTop = scrollTop;
    },
    submitSwitchDept: function submitSwitchDept() {
      var self = this;
      if (self.userDept) {
        Lib.M.ajax({
          'method': "put",
          'url': 'user/switch_dept',
          'data': {
            reqType: 'web',
            deptId: self.userDept
          },
          'success': function success(data) {
            sessionStorage.setItem("data", JSON.stringify(data.obj));
            self.changeDeptDialog = false;
            self.tokenLogin();
            sessionStorage.setItem('isRefreshed', 'true');
            self.$message.success(data.userInfo);
          },
          "error": function error(data) {
            self.$message({
              message: data.userInfo,
              type: "warning"
            });
          }
        });
      } else {
        self.$message.warning("请选择部门");
      }
    },
    resetDeptFilter: function resetDeptFilter() {
      var data = JSON.parse(sessionStorage.getItem('data')).dept;
      if (data.branchUnitName && data.projectUnitName) {
        this.filterText = data.projectUnitName;
        this.deptId = [data.projectUnitId];
        return;
      } else if (data.branchUnitName) {
        this.filterText = data.branchUnitName;
        this.deptId = [data.branchUnitId];
        return;
      } else {
        this.filterText = "水电七局";
      }
      this.deptId = [];
    },
    filterNode: function filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.deptName.indexOf(value) !== -1;
    },
    getDepts: function getDepts() {
      var _this5 = this;
      this.$get('/dept/units').then(function (res) {
        _this5.queryDept = res.obj;
        // 默认给所有单位填充
        _this5.deptId = [res.obj[0].deptId];
        _this5.$removeEmptyAttr(res.obj[0]);
        _this5.setUnits(res.obj);
      });
    },
    getDeptsV2: function getDeptsV2() {
      var _this6 = this;
      this.$get('/dept/unitsV2').then(function (res) {
        _this6.$removeEmptyAttr(res.obj[0]);
        _this6.setSeflUnits(res.obj);
      });
    },
    handleNodeClick: function handleNodeClick(data, node, component) {
      //七局id看所有车辆
      var arr = [];
      this.searchParentNode(node, arr);
      arr = arr.reverse();
      this.deptId = arr;
      this.filterText = data.deptName;
      this.isShowDept = false;
    },
    searchParentNode: function searchParentNode(node, arr) {
      if (node.parent != null) {
        arr.push(node.data.deptId);
        this.searchParentNode(node.parent, arr);
      } else {
        return;
      }
    },
    switchTips: function switchTips(tab) {
      this.tips = tab.name;
    },
    //获得未读消息数量
    getUnreadMsg: function getUnreadMsg(data, allCount, messageListCount, todoListCount) {
      this.$store.dispatch("dispatchGetAllCount", allCount);
      this.$store.dispatch("dispatchGetMessageListCount", messageListCount);
      this.$store.dispatch("dispatchGetTodoListCount", todoListCount);
      this.$store.dispatch("dispatchListSwitch", data);
    },
    //点击菜单
    selectItem: function selectItem(index, indexPath) {
      console.log('indexPath', indexPath);
      // let data = JSON.parse(sessionStorage.getItem('data'));

      // if(data.level=='low'){
      //   console.log('indexPath[0]', indexPath[0]);
      //  if (indexPath[0]!= '/main/dataScreening' ) {
      //    console.log('路由');
      //  	this.$router.push({ path: "/main/personalSafe"});
      //  }
      // }
    },
    confirmChoose: function confirmChoose(isShow) {
      console.log('isShow', isShow);
      var data = JSON.parse(sessionStorage.getItem('data'));
      if (data.level == 'low') {
        this.dialogV2 = true;
      } else {
        this.dialogV2 = false;
      }
      if (this.calculateDaysBetween(data.pwdUpdateAt) > 90) {
        this.pwdUpdateAt = this.getTimeAfterNinetyDays(data.pwdUpdateAt);
        this.dialogV3 = true;
      } else {
        this.dialogV3 = false;
      }
      if (isShow) {
        //
        this.collapse = false;
        this.isToolbarVisible = true;
      } else {
        this.isToolbarVisible = false;
        this.collapse = true;
      }
    },
    calculateDaysBetween: function calculateDaysBetween(startDateStr) {
      var startDate = new Date(startDateStr);
      var endDate = new Date();
      var diffInMilliseconds = endDate - startDate;
      return Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
    },
    getTimeAfterNinetyDays: function getTimeAfterNinetyDays(value) {
      var now = new Date(value);
      now.setDate(now.getDate() + 90);
      var formattedTime = now.toLocaleString('zh-CN', {
        hour12: false,
        // 使用24小时制
        timeZone: 'Asia/Shanghai' // 指定时区，确保时分秒正确
      });
      return formattedTime;
    },
    confirmOtherChoose: function confirmOtherChoose(isShow) {
      console.log('isShow2', isShow);
      if (isShow) {
        //
        this.collapse = false;
        this.isToolbarVisible = true;
      } else {
        this.isToolbarVisible = false;
        this.collapse = true;
      }
    },
    clickTodoList: function clickTodoList(item) {
      var _this7 = this;
      this.auditId = '';
      if (item.subType == 'questionDaily') {
        this.auditId = item.pId;
        this.audit(item.pId);
        return;
      }
      if (item.subType == 'materialMessage') {
        this.$refs.chatDialog.show(item, 'reply');
        return;
      }
      if (item.text && item.text.indexOf('制度文件') > 0) {
        this.$get("/basic-file/businessId/".concat(item.pId, "/list")).then(function (res) {
          if (res.obj) {
            if (res.obj.length > 0) {
              window.open(res.obj[0].fileRealUrl);
            }
          }
          if (_this7.pData.userId !== 'user-20180621112337-2ta3adkg') {
            _this7.$get("/rule/open-file/".concat(item.pId)).then(function (res) {});
          }
          _this7.$put('/rule/deal', {
            msgId: item.msgId
          }).then(function (res) {
            _this7.getUnreadMsgCnt();
          });
        });
        return;
      }
      item["auditResult"] = -1;
      // 判断是不是签认单审核
      if (item.subType == 'confirmOrderFormDetails') {
        this.$router.push("/main/confirmOrderManage/detail?id=".concat(item.pId));
        return;
      }
      if (item.subType == 'specialVehicleSecurityCheckEdit') {
        this.$router.push("/main/specialVehicleSecurityCheckDetail?id=".concat(item.pId));
        return;
      }
      this.$router.push({
        path: "/main/" + item.subType,
        query: item
      });
      // this.unRead(item);
    },
    getMessage: function getMessage() {
      var _this8 = this;
      this.$get("/jpush/getAllJMessage/".concat(JSON.parse(sessionStorage.getItem("data")).userId), {
        // isRead:1,
        type: "0",
        pageNum: 1,
        pageSize: 5
      }).then(function (res) {
        _this8.showBadge = false, _this8.getMessageInfo = res.obj.data;
      });
    },
    readAllMessage: function readAllMessage() {
      var _this9 = this;
      this.$put('jpush/read-all-notice-message').then(function (res) {
        _this9.getMessage();
      });
    },
    gotoDetails: function gotoDetails(row) {
      this.$router.push({
        path: "/main/messageDetails",
        query: {
          id: row
        }
      });
      this.showMessageFlag = false;
      return;
    },
    unRead: function unRead(item) {
      var _this10 = this;
      this.$confirm('是否确认删除已选中的消息？', '提示', {
        type: 'warning'
      }).then(function (res) {
        var self = _this10;
        self.loading = true;
        Lib.M.ajax({
          'method': "delete",
          'url': 'jpush/batch/',
          'params': {},
          'data': [item.msgId],
          'success': function success(data) {
            self.loading = false;
            self.$message({
              message: data.userInfo,
              type: 'success'
            });
            self.getMessage();
          },
          "error": function error(data) {
            self.loading = false;
            self.$message({
              message: data.userInfo,
              type: "warning"
            });
          }
        });
      });

      // let self = this;
      // Lib.M.ajax({
      //   'method': "put",
      //   'url': '/jpush/updateUnRead',
      //   'params': {
      //     msgId: item.msgId
      //   },
      //   'success': function (data) {
      //     self.getUnreadMsgCnt();
      //   },
      //   "error": function (data) { }
      // })
    },
    //点击铃铛
    clickNatifications: function clickNatifications() {
      this.getUnreadMsgCnt();
    },
    handleClick: function handleClick(tab, event) {
      this.activeName = tab.name;
      // this.getUnreadMsgCnt();
    },
    handleChange: function handleChange(val) {
      this.value = val;
      this.$router.push('/main' + val);
    },
    personalCenter: function personalCenter(router) {
      // alert(router)
      if (router === "/") {
        // alert(router)
        this.retreatSafely(router);
      } else if (router === '/changeDept') {
        this.changeDeptDialog = true;
      } else {
        this.$router.push(router);
      }
      this.headPopover = false;
    },
    // safe quit
    retreatSafely: function retreatSafely(router) {
      var self = this;
      Lib.M.ajax({
        'method': "put",
        'url': 'user/retreatSafely',
        'params': {},
        'data': {},
        'success': function success(data) {
          self.$router.push(router);
          sessionStorage.clear();
          localStorage.clear();
          self.$message({
            message: data.userInfo,
            type: "success"
          });
        },
        "error": function error(data) {
          self.$message({
            message: data.userInfo,
            type: "warning"
          });
        }
      });
    },
    goTodoList: function goTodoList() {
      this.showTodoFlag = false;
      this.$router.push({
        path: '/main/todoList'
      });
    },
    goMessageInfo: function goMessageInfo() {
      this.showMessageFlag = false;
      this.$router.push({
        path: '/main/messageInfo'
      });
    },
    clickSlide: function clickSlide() {
      this.collapse = !this.collapse;
      this.drawer = !this.drawer;
      if (this.$route.name && (this.$route.name == 'dataScreening' || this.$route.name == 'specialEquipmentManage' || this.$route.name == 'international/dataScreening')) {
        //数据大屏
        if (this.collapse) {
          this.isToolbarVisible = false;
        } else {
          this.isToolbarVisible = true;
        }
        // this.isToolbarVisible =false ;
      } else {
        this.isToolbarVisible = true;
      }

      // if(this.collapse){
      // 	 this.isToolbarVisible =false ;
      // }else{
      // 	 this.isToolbarVisible =true ;
      // }
    },
    tokenLogin: function tokenLogin() {
      var token = JSON.parse(localStorage.getItem('token'));
      var self = this;
      if (token) {
        self.fullscreenLoading = true;
        Lib.M.ajax({
          'method': "get",
          'url': 'user/verify',
          'params': {},
          'data': {},
          'headers': {
            token: token.tokenId.replace(/"/g, "")
          },
          'success': function success(data) {
            sessionStorage.setItem("data", JSON.stringify(data.obj.user));
            sessionStorage.setItem("token", JSON.stringify(data.obj.token));
            localStorage.setItem("token", JSON.stringify(data.obj.token));
            sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
            //sessionStorage.setItem("menuEng", JSON.stringify(self.filterEmptyArr(data.obj.menuEng)));
            sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
            self.$store.dispatch("dispatchIsLogin", 1);
            // self.$router.push("/main/basicData");
            window.location.reload();
          },
          "error": function error(data) {
            if (data.code) {
              self.$message({
                message: data.userInfo,
                type: "warning"
              });
            } else {
              self.$message({
                message: "登录失效，请重新登录",
                type: "warning"
              });
            }
          }
        });
      }
    },
    gotoDataScreening: function gotoDataScreening() {
      if (this.pData.dept.branchUnitId) {
        if (this.pData.dept.branchUnitId === 'dept-20230209092043-mq40sqtk' || this.pData.dept.branchUnitId === 'dept-20190923113717-1j4004gd') {
          this.$router.push({
            path: '/main/international/dataScreening'
          });
        } else {
          this.$router.push({
            path: '/main/dataScreening'
          });
        }
      } else {
        this.$router.push({
          path: '/main/dataScreening'
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this11 = this;
    // window.addEventListener("scroll", (e) => {
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   console.log(scrollTop)
    //   this.stickyTop=scrollTop;
    //
    // })
    this.startInterval();
    this.$nextTick(function () {
      _this11.box = _this11.$refs.box;
    });
    var data = JSON.parse(sessionStorage.getItem('data'));
    var token = JSON.parse(sessionStorage.getItem('token'));
    var menu = JSON.parse(sessionStorage.getItem("menu"));
    cn.list = menu;
    this.$i18n.setLocaleMessage("cn", cn);
    this.$i18n.locale = 'cn';
    this.nameSlot = data.userName;
    if (token) {
      this.androidApkUrl = token.androidApkUrl;
      this.iosApkUrl = token.iosApkUrl;
    }
    if (null != data.imgUrl && "" !== data.imgUrl) {
      this.headImg = data.imgUrl;
    } else {
      this.sex = data.sex;
    }
    if (data.dept.branchUnitName && data.dept.projectUnitName) {
      this.filterText = data.dept.projectUnitName;
    } else if (data.dept.branchUnitName) {
      this.filterText = data.dept.branchUnitName;
    } else {
      this.filterText = "水电七局";
    }
    // this.deptId=data.projectUnitId;
  }
};